import React from 'react'
import PropTypes from 'prop-types'

import image from 'images/projects/projects-dashbaord.png'

function EmptyAboutSection({ isDesigner }) {
  return (
    <div className="projects-empty__about">
      <div className="container-fixed">
        <div className="row">
          <div className="col-12 col-md-6 order-md-2">
            <img src={image} alt="" />
          </div>
          {isDesigner ? (
            <div className="col-12 col-md-6 order-md-1">
              <div className="projects-empty__about-text">
                <h4 className="heading-24">Find your next freelance 3D Project!</h4>
                <p>CGTrader 3D Projects is the most specialized 3D freelance portal globally. Apply to 3D Projects or invite
                  your clients to CGTrader and take advantage of the lowest fees in the industry, various payment options,
                  our escrow service and dispute management more. Save time on legal contracts and portfolio presentation for
                  your private projects – everything’s already available on CGTrader.
                </p>
              </div>
            </div>
          ) : (
            <div className="col-12 col-md-6 order-md-1">
              <div className="projects-empty__about-text">
                <h4 className="heading-24">Hire designers for your 3D Projects!</h4>
                <p>CGTrader 3D Projects help you discover freelance 3D designers in our community. Post custom modelling
                  requests and hire experienced freelancers with their portfolios available at a single click.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

EmptyAboutSection.propTypes = {
  isDesigner: PropTypes.bool.isRequired,
}

export default EmptyAboutSection
